import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center justify-between px-4 py-3 bg-white sm:px-6" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between flex-1" }
const _hoisted_4 = { class: "w-full md:w-[70%] text-center md:text-right" }
const _hoisted_5 = {
  class: "relative z-0 inline-flex -space-x-px rounded-lg",
  "aria-label": "Pagination"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/24/solid";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'PagePagination',
  props: {
    items: Object || null,
    rowCount: {
      type: Number,
      default: 10
    },
    goToPage: {
      type: String,
      default: null
    }
  },
  setup(__props) {


  
return (_ctx: any,_cache: any) => {
  return (__props.items?.total > 3)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full md:w-[30%] mb-6 md:mb-0 flex items-center justify-between md:justify-start" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("nav", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.links, (link, key) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                    (key === 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.$emit('nextPage', link.url)),
                          class: "relative inline-flex items-center px-2 py-2 bg-white text-sm font-medium text-gray-500 hover:bg-gray-[#F3F4F6]"
                        }, [
                          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Previous", -1)),
                          _createVNode(_unref(ChevronLeftIcon), {
                            class: "w-5 h-5",
                            "aria-hidden": "true"
                          })
                        ], 8, _hoisted_6))
                      : (key === __props.items.links.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.$emit('nextPage', link.url)),
                            class: "relative inline-flex items-center px-2 py-2 bg-white text-sm font-medium text-gray-500 hover:bg-gray-[#F3F4F6]"
                          }, [
                            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Next", -1)),
                            _createVNode(_unref(ChevronRightIcon), {
                              class: "w-5 h-5",
                              "aria-hidden": "true"
                            })
                          ], 8, _hoisted_7))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: ($event: any) => (_ctx.$emit('nextPage', link.url)),
                            "aria-current": "page",
                            class: _normalizeClass(
                    link.active
                      ? 'z-10 bg-[#F3F4F6] border-[#F3F4F6] relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-lg'
                      : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg'
                  )
                          }, _toDisplayString(link.label), 11, _hoisted_8))
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})